import React, { FC } from 'react';
import styled from 'styled-components';
import { mobile, tablet, useQuery } from 'styles/breakpoints';
import ContinueButton from './QuizContinueButton';
import { Question } from 'types/quiz';
import { DynamicImage } from 'components';

interface ImageQuestionProps {
  question: Question;
  onContinue: () => void;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  max-width: 71.25rem;
  width: 100%;
  margin: 0 auto;
`;

const StyledDynamicImage = styled(DynamicImage)<{
  imageHeightDesktop: string;
  imageHeightTablet: string;
  imageHeightMobile: string;
  imageMaxHeight: string;
}>`
  max-width: 71.25rem;
  max-height: ${({ imageMaxHeight }) => imageMaxHeight};
  height: ${({ imageHeightDesktop }) => imageHeightDesktop};
  margin: 3rem auto auto;

  @media ${tablet} {
    height: ${({ imageHeightTablet }) => imageHeightTablet};
    margin-bottom: 1.5rem;
  }

  @media ${mobile} {
    max-width: unset;
    height: auto;
    width: 100%;

    margin-top: 1rem;
    margin-bottom: 7rem;
  }
`;

export const ImageQuestion: FC<ImageQuestionProps> = ({
  question,
  onContinue,
  ...props
}) => {
  const { isMobile } = useQuery();

  return (
    <Container {...props}>
      {isMobile ? (
        <StyledDynamicImage
          src={question.mobileImg}
          alt={question.alt}
          imageHeightDesktop={question.imageHeightDesktop}
          imageHeightTablet={question.imageHeightTablet}
          imageHeightMobile={question.imageHeightMobile}
          imageMaxHeight={question.maxHeight}
        />
      ) : (
        <StyledDynamicImage
          src={question.desktopImg}
          alt={question.alt}
          imageHeightDesktop={question.imageHeightDesktop}
          imageHeightTablet={question.imageHeightTablet}
          imageHeightMobile={question.imageHeightMobile}
          imageMaxHeight={question.maxHeight}
        />
      )}
      <ContinueButton onClick={onContinue} title={question?.nextBtnTitle} />
    </Container>
  );
};
